import { HelpCircle } from 'lucide-react';
import { GuideCategory } from './types';

export const gettingStartedGuide: GuideCategory = {
  id: 'getting-started',
  title: 'Getting Started',
  icon: HelpCircle,
  articles: [
    {
      slug: 'platform-overview',
      title: 'Platform Overview',
      description: 'Understand the core concepts of our ball bouncing simulator.',
      sections: [
        {
          id: 'what-is-it',
          title: 'What is this Ball Engine?',
          content: 'Our platform is a high-performance ball engine on browser designed for making rhythmic ball physics simulations. It allows you to create satisfying videos by syncing complex ball bouncing interactions with audio beats.'
        },
        {
          id: 'core-workflow',
          title: 'Creating Your First Ball Simulation',
          content: '1. Pick a Mode: Choose a style like "Rhythmic" for music-synced ball bouncing.\n2. Choose a Beat: Use our library or upload your own track to drive the ball engine.\n3. Customize: Change ball physics, colors, and effects to match your vision.\n4. Share: Export your ball bouncing video and share it on social media!'
        }
      ]
    },
    {
      slug: 'account-management',
      title: 'My Account & Presets',
      description: 'Managing your profile and your saved ball bouncing simulation settings.',
      sections: [
        {
          id: 'profile-setup',
          title: 'Your Creator Profile',
          content: 'Your account is where you store your unique ball engine presets. Sign up to ensure your custom physics configurations are saved to the cloud.'
        },
        {
          id: 'cloud-storage',
          title: 'Storage for Audio & Presets',
          content: 'We provide cloud storage specifically for your custom audio uploads and ball bouncing simulator presets. You can manage these in the Studio interface.'
        }
      ]
    }
  ]
};
